import { createChangeProcessors } from './changeProcessors';
import { executePredicatedProcessors } from '../../lib/predicatedProcessor';
import createMergeDiffBuffer from './mergeBuffer';
import type { MergeBufferItem, MergeDiffFormatter } from './types';


const mergeDiffFormatter: MergeDiffFormatter<MergeBufferItem[]> = ({
  A, B, changes, formattedOperation,
}) => {
  const processingBuffer = createMergeDiffBuffer();

  const changeProcessors = createChangeProcessors({
    A,
    B,
    entriesBuffer: processingBuffer,
    formattedOperation,
  });

  executePredicatedProcessors({
    items: changes,
    processorRegistry: changeProcessors,
  });

  return processingBuffer.package();
};

export default mergeDiffFormatter;
